define([
    "knockout",
    "core/resx",
    "helpers/routerHelper",
    "services/dispatchService",
    "helpers/enumHelper"
], function (ko, resx, routerHelper, dispatchService, enumHelper) {
    "use strict";

    var viewModel = (function () {
        var self = null;

        function ctor() {
            self = this;
            //#region Properties
            self.resx = resx;

            self.workOrderId = ko.observable();
            self.dispatchId = ko.observable('');
            self.reason = ko.observable('');
            //#endregion
        }

        //#region Private Functions
        function clear() {
            self.reason('');
        }
        
        function loadData(self) {
            self.temp = ko.observable();
        }

        function bindViewModel(workOrderId, dispatchId) {
            self.workOrderId(workOrderId);
            self.dispatchId(dispatchId);
        }
        //#endregion

        //#region Public Functions
        ctor.prototype.activate = function (params) {
            clear();
            bindViewModel(params.workOrderId, params.dispatchId);

            return loadData(self);
        };

        ctor.prototype.setReason = function() {
            dispatchService.setWorkorderAttendanceStatus(self.workOrderId(), self.dispatchId(), { Presence: enumHelper.attendance().ABSENT, AbsenceReason: self.reason() })
                .done(routerHelper.navigateBack);
        };
        //#endregion
        return ctor;
    })();

    return viewModel;
});
